/**
 * Every language sum.video ships in: the union of the App Store Connect and
 * Google Play listing languages. Web routes, app UI, summaries and store
 * listings all derive from this list.
 */
export const LANGUAGES = [
  {
    code: "en",
    englishName: "English",
    nativeName: "English",
    flag: "🇺🇸",
    ogLocale: "en_US",
  },
  {
    code: "hu",
    englishName: "Hungarian",
    nativeName: "Magyar",
    flag: "🇭🇺",
    ogLocale: "hu_HU",
  },
  {
    code: "pl",
    englishName: "Polish",
    nativeName: "Polski",
    flag: "🇵🇱",
    ogLocale: "pl_PL",
  },
  {
    code: "de",
    englishName: "German",
    nativeName: "Deutsch",
    flag: "🇩🇪",
    ogLocale: "de_DE",
  },
  {
    code: "es",
    englishName: "Spanish",
    nativeName: "Español",
    flag: "🇪🇸",
    ogLocale: "es_ES",
  },
  {
    code: "fr",
    englishName: "French",
    nativeName: "Français",
    flag: "🇫🇷",
    ogLocale: "fr_FR",
  },
  {
    code: "it",
    englishName: "Italian",
    nativeName: "Italiano",
    flag: "🇮🇹",
    ogLocale: "it_IT",
  },
  {
    code: "pt",
    englishName: "Brazilian Portuguese",
    nativeName: "Português",
    flag: "🇧🇷",
    ogLocale: "pt_BR",
  },
  {
    code: "ru",
    englishName: "Russian",
    nativeName: "Русский",
    flag: "🇷🇺",
    ogLocale: "ru_RU",
  },
  {
    code: "ja",
    englishName: "Japanese",
    nativeName: "日本語",
    flag: "🇯🇵",
    ogLocale: "ja_JP",
  },
  {
    code: "ko",
    englishName: "Korean",
    nativeName: "한국어",
    flag: "🇰🇷",
    ogLocale: "ko_KR",
  },
  {
    code: "zh",
    englishName: "Simplified Chinese",
    nativeName: "简体中文",
    flag: "🇨🇳",
    ogLocale: "zh_CN",
  },
  {
    code: "id",
    englishName: "Indonesian",
    nativeName: "Bahasa Indonesia",
    flag: "🇮🇩",
    ogLocale: "id_ID",
  },
  {
    code: "nl",
    englishName: "Dutch",
    nativeName: "Nederlands",
    flag: "🇳🇱",
    ogLocale: "nl_NL",
  },
  {
    code: "ar",
    englishName: "Arabic",
    nativeName: "العربية",
    flag: "🇸🇦",
    ogLocale: "ar_SA",
  },
  {
    code: "hi",
    englishName: "Hindi",
    nativeName: "हिन्दी",
    flag: "🇮🇳",
    ogLocale: "hi_IN",
  },
  {
    code: "tr",
    englishName: "Turkish",
    nativeName: "Türkçe",
    flag: "🇹🇷",
    ogLocale: "tr_TR",
  },
  {
    code: "af",
    englishName: "Afrikaans",
    nativeName: "Afrikaans",
    flag: "🇿🇦",
    ogLocale: "af_ZA",
  },
  {
    code: "am",
    englishName: "Amharic",
    nativeName: "አማርኛ",
    flag: "🇪🇹",
    ogLocale: "am_ET",
  },
  {
    code: "az",
    englishName: "Azerbaijani",
    nativeName: "Azərbaycan",
    flag: "🇦🇿",
    ogLocale: "az_AZ",
  },
  {
    code: "be",
    englishName: "Belarusian",
    nativeName: "Беларуская",
    flag: "🇧🇾",
    ogLocale: "be_BY",
  },
  {
    code: "bg",
    englishName: "Bulgarian",
    nativeName: "Български",
    flag: "🇧🇬",
    ogLocale: "bg_BG",
  },
  {
    code: "bn",
    englishName: "Bengali",
    nativeName: "বাংলা",
    flag: "🇧🇩",
    ogLocale: "bn_BD",
  },
  {
    code: "ca",
    englishName: "Catalan",
    nativeName: "Català",
    flag: "🇦🇩",
    ogLocale: "ca_ES",
  },
  {
    code: "cs",
    englishName: "Czech",
    nativeName: "Čeština",
    flag: "🇨🇿",
    ogLocale: "cs_CZ",
  },
  {
    code: "da",
    englishName: "Danish",
    nativeName: "Dansk",
    flag: "🇩🇰",
    ogLocale: "da_DK",
  },
  {
    code: "el",
    englishName: "Greek",
    nativeName: "Ελληνικά",
    flag: "🇬🇷",
    ogLocale: "el_GR",
  },
  {
    code: "et",
    englishName: "Estonian",
    nativeName: "Eesti",
    flag: "🇪🇪",
    ogLocale: "et_EE",
  },
  {
    code: "eu",
    englishName: "Basque",
    nativeName: "Euskara",
    flag: "🏳️",
    ogLocale: "eu_ES",
  },
  {
    code: "fa",
    englishName: "Persian",
    nativeName: "فارسی",
    flag: "🇮🇷",
    ogLocale: "fa_IR",
  },
  {
    code: "fi",
    englishName: "Finnish",
    nativeName: "Suomi",
    flag: "🇫🇮",
    ogLocale: "fi_FI",
  },
  {
    code: "fil",
    englishName: "Filipino",
    nativeName: "Filipino",
    flag: "🇵🇭",
    ogLocale: "tl_PH",
  },
  {
    code: "gl",
    englishName: "Galician",
    nativeName: "Galego",
    flag: "🏳️",
    ogLocale: "gl_ES",
  },
  {
    code: "gu",
    englishName: "Gujarati",
    nativeName: "ગુજરાતી",
    flag: "🇮🇳",
    ogLocale: "gu_IN",
  },
  {
    code: "he",
    englishName: "Hebrew",
    nativeName: "עברית",
    flag: "🇮🇱",
    ogLocale: "he_IL",
  },
  {
    code: "hr",
    englishName: "Croatian",
    nativeName: "Hrvatski",
    flag: "🇭🇷",
    ogLocale: "hr_HR",
  },
  {
    code: "hy",
    englishName: "Armenian",
    nativeName: "Հայերեն",
    flag: "🇦🇲",
    ogLocale: "hy_AM",
  },
  {
    code: "is",
    englishName: "Icelandic",
    nativeName: "Íslenska",
    flag: "🇮🇸",
    ogLocale: "is_IS",
  },
  {
    code: "ka",
    englishName: "Georgian",
    nativeName: "ქართული",
    flag: "🇬🇪",
    ogLocale: "ka_GE",
  },
  {
    code: "kk",
    englishName: "Kazakh",
    nativeName: "Қазақ тілі",
    flag: "🇰🇿",
    ogLocale: "kk_KZ",
  },
  {
    code: "km",
    englishName: "Khmer",
    nativeName: "ខ្មែរ",
    flag: "🇰🇭",
    ogLocale: "km_KH",
  },
  {
    code: "kn",
    englishName: "Kannada",
    nativeName: "ಕನ್ನಡ",
    flag: "🇮🇳",
    ogLocale: "kn_IN",
  },
  {
    code: "ky",
    englishName: "Kyrgyz",
    nativeName: "Кыргызча",
    flag: "🇰🇬",
    ogLocale: "ky_KG",
  },
  {
    code: "lo",
    englishName: "Lao",
    nativeName: "ລາວ",
    flag: "🇱🇦",
    ogLocale: "lo_LA",
  },
  {
    code: "lt",
    englishName: "Lithuanian",
    nativeName: "Lietuvių",
    flag: "🇱🇹",
    ogLocale: "lt_LT",
  },
  {
    code: "lv",
    englishName: "Latvian",
    nativeName: "Latviešu",
    flag: "🇱🇻",
    ogLocale: "lv_LV",
  },
  {
    code: "mk",
    englishName: "Macedonian",
    nativeName: "Македонски",
    flag: "🇲🇰",
    ogLocale: "mk_MK",
  },
  {
    code: "ml",
    englishName: "Malayalam",
    nativeName: "മലയാളം",
    flag: "🇮🇳",
    ogLocale: "ml_IN",
  },
  {
    code: "mn",
    englishName: "Mongolian",
    nativeName: "Монгол",
    flag: "🇲🇳",
    ogLocale: "mn_MN",
  },
  {
    code: "mr",
    englishName: "Marathi",
    nativeName: "मराठी",
    flag: "🇮🇳",
    ogLocale: "mr_IN",
  },
  {
    code: "ms",
    englishName: "Malay",
    nativeName: "Bahasa Melayu",
    flag: "🇲🇾",
    ogLocale: "ms_MY",
  },
  {
    code: "my",
    englishName: "Burmese",
    nativeName: "မြန်မာ",
    flag: "🇲🇲",
    ogLocale: "my_MM",
  },
  {
    code: "nb",
    englishName: "Norwegian Bokmål",
    nativeName: "Norsk bokmål",
    flag: "🇳🇴",
    ogLocale: "nb_NO",
  },
  {
    code: "ne",
    englishName: "Nepali",
    nativeName: "नेपाली",
    flag: "🇳🇵",
    ogLocale: "ne_NP",
  },
  {
    code: "or",
    englishName: "Odia",
    nativeName: "ଓଡ଼ିଆ",
    flag: "🇮🇳",
    ogLocale: "or_IN",
  },
  {
    code: "pa",
    englishName: "Punjabi (Gurmukhi)",
    nativeName: "ਪੰਜਾਬੀ",
    flag: "🇮🇳",
    ogLocale: "pa_IN",
  },
  {
    code: "pt-PT",
    englishName: "European Portuguese",
    nativeName: "Português (Portugal)",
    flag: "🇵🇹",
    ogLocale: "pt_PT",
  },
  {
    code: "rm",
    englishName: "Romansh",
    nativeName: "Rumantsch",
    flag: "🇨🇭",
    ogLocale: "rm_CH",
  },
  {
    code: "ro",
    englishName: "Romanian",
    nativeName: "Română",
    flag: "🇷🇴",
    ogLocale: "ro_RO",
  },
  {
    code: "si",
    englishName: "Sinhala",
    nativeName: "සිංහල",
    flag: "🇱🇰",
    ogLocale: "si_LK",
  },
  {
    code: "sk",
    englishName: "Slovak",
    nativeName: "Slovenčina",
    flag: "🇸🇰",
    ogLocale: "sk_SK",
  },
  {
    code: "sl",
    englishName: "Slovenian",
    nativeName: "Slovenščina",
    flag: "🇸🇮",
    ogLocale: "sl_SI",
  },
  {
    code: "sq",
    englishName: "Albanian",
    nativeName: "Shqip",
    flag: "🇦🇱",
    ogLocale: "sq_AL",
  },
  {
    code: "sr",
    englishName: "Serbian (Cyrillic)",
    nativeName: "Српски",
    flag: "🇷🇸",
    ogLocale: "sr_RS",
  },
  {
    code: "sv",
    englishName: "Swedish",
    nativeName: "Svenska",
    flag: "🇸🇪",
    ogLocale: "sv_SE",
  },
  {
    code: "sw",
    englishName: "Swahili",
    nativeName: "Kiswahili",
    flag: "🇰🇪",
    ogLocale: "sw_KE",
  },
  {
    code: "ta",
    englishName: "Tamil",
    nativeName: "தமிழ்",
    flag: "🇮🇳",
    ogLocale: "ta_IN",
  },
  {
    code: "te",
    englishName: "Telugu",
    nativeName: "తెలుగు",
    flag: "🇮🇳",
    ogLocale: "te_IN",
  },
  {
    code: "th",
    englishName: "Thai",
    nativeName: "ไทย",
    flag: "🇹🇭",
    ogLocale: "th_TH",
  },
  {
    code: "uk",
    englishName: "Ukrainian",
    nativeName: "Українська",
    flag: "🇺🇦",
    ogLocale: "uk_UA",
  },
  {
    code: "ur",
    englishName: "Urdu",
    nativeName: "اردو",
    flag: "🇵🇰",
    ogLocale: "ur_PK",
  },
  {
    code: "vi",
    englishName: "Vietnamese",
    nativeName: "Tiếng Việt",
    flag: "🇻🇳",
    ogLocale: "vi_VN",
  },
  {
    code: "zh-Hant",
    englishName: "Traditional Chinese",
    nativeName: "繁體中文",
    flag: "🇹🇼",
    ogLocale: "zh_TW",
  },
  {
    code: "zu",
    englishName: "Zulu",
    nativeName: "isiZulu",
    flag: "🇿🇦",
    ogLocale: "zu_ZA",
  },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]["code"];

export type LanguageInfo = (typeof LANGUAGES)[number];

export const LANGUAGE_CODES = LANGUAGES.map(
  (language) => language.code,
) as unknown as readonly [LanguageCode, ...LanguageCode[]];

const RTL_LANGUAGES: ReadonlySet<string> = new Set(["ar", "fa", "he", "ur"]);

export function isLanguageCode(value: unknown): value is LanguageCode {
  return LANGUAGE_CODES.some((code) => code === value);
}

export function isLanguagePreference(
  value: unknown,
): value is LanguageCode | "auto" {
  return value === "auto" || isLanguageCode(value);
}

export function languageInfo(code: LanguageCode): LanguageInfo {
  const info = LANGUAGES.find((language) => language.code === code);
  if (!info) {
    throw new Error(`Unknown language: ${code}`);
  }
  return info;
}

/**
 * The language tag for html lang and hreflang. Search engines validate
 * hreflang against ISO 639-1, which has no code for Filipino, so the fil
 * locale is tagged with its ISO 639-1 equivalent, Tagalog (tl). URLs keep
 * the locale code.
 */
export function languageTag(code: LanguageCode): string {
  return code === "fil" ? "tl" : code;
}

export function isRtlLanguage(value: string): boolean {
  const base = value.trim().toLowerCase().split("-")[0] ?? "";
  return RTL_LANGUAGES.has(base);
}

/**
 * Maps a BCP 47 tag from a browser, OS or store (e.g. "pt-PT", "zh-TW",
 * "no", "in") to the closest supported language.
 */
export function resolveLanguageTag(
  value: string | null | undefined,
): LanguageCode | null {
  if (!value) {
    return null;
  }
  const parts = value.trim().replace(/_/g, "-").toLowerCase().split("-");
  const base = parts[0] ?? "";
  const rest = parts.slice(1);
  if (base === "zh") {
    const traditional = rest.some((part) =>
      ["hant", "tw", "hk", "mo"].includes(part),
    );
    return traditional ? "zh-Hant" : "zh";
  }
  if (base === "pt") {
    return rest.includes("pt") ? "pt-PT" : "pt";
  }
  const aliased = BASE_ALIASES[base] ?? base;
  return isLanguageCode(aliased) ? aliased : null;
}

const BASE_ALIASES: Record<string, LanguageCode> = {
  in: "id",
  iw: "he",
  no: "nb",
  nn: "nb",
  tl: "fil",
};
